import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

import DropdownMenu from '../../shared/dropdownMenu';
import {
  connectionTemplatesDetailsPropType,
} from '../../administration/beginningBalancesPage/propTypes';

import { generateAndDownloadXlsxTemplateForConnectionBatchProvision } from './generateXlxsTemplate';


const HamburgerDropdown = ({
  periodName,
  connection,
  companyCodesForConnection,
  environmentSuffix,
  isLoadingCompanyCodesForConnection,
  additionalItems,
}) => {
  const dropdownRef = useRef(null);

  const hideDropdown = useCallback(() => {
    dropdownRef.current.hideDropDown();
  }, []);

  const generateTemplate = useCallback(async () => {
    await generateAndDownloadXlsxTemplateForConnectionBatchProvision({
      periodName,
      connectionName: connection.connName,
      connectionTemplateDetails: companyCodesForConnection,
      environmentSuffix,
    });
    hideDropdown();
  }, [periodName, connection, companyCodesForConnection, environmentSuffix, hideDropdown]);


  return (
    <DropdownMenu ref={dropdownRef} contentClassName="hamburger-menu">
      <button
        className="hamburger-action link-button"
        onClick={generateTemplate}
        disabled={!connection || isLoadingCompanyCodesForConnection}
      >
        Download Trial Balance Template
      </button>
      {additionalItems}
    </DropdownMenu>
  );
};


HamburgerDropdown.propTypes = {
  periodName: PropTypes.string.isRequired,
  connection: PropTypes.shape({
    connName: PropTypes.string.isRequired,
  }),
  companyCodesForConnection: connectionTemplatesDetailsPropType,
  isLoadingCompanyCodesForConnection: PropTypes.bool.isRequired,
  environmentSuffix: PropTypes.string.isRequired,
  additionalItems: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default HamburgerDropdown;
